import React from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";

const ModalDNASentSuccessfully = ({ showModal, setShowModal }) => {
  const { t } = useTranslation();

  return (
    <ModalContainer
      modalTitle={t("Success")}
      isOpen={showModal}
      closeModal={() => setShowModal(false)}
      crossmarkAction={() => setShowModal(false)}
    >
      {t("An email was sent to the candidate to complete the DOC Online.")}
    </ModalContainer>
  );
};

export default ModalDNASentSuccessfully;
